// extracted by mini-css-extract-plugin
export var arrow = "s0+8k";
export var previous = "uAv4M";